import { create } from "zustand";

interface TransferState {
  selectedBank: string;
  setSelectedBank: (value: string) => void;
  transferAmount: number;
  setTransferAmount: (value: number) => void;
  accountNumber: string;
  setAccountNumber: (value: string) => void;
  updateFormValues: (values: Partial<TransferState>) => void;
}

export const useTransferStore = create<TransferState>((set) => ({
  selectedBank: "",
  setSelectedBank: (value) => set(() => ({ selectedBank: value })),
  transferAmount: 0,
  setTransferAmount: (value) => set(() => ({ transferAmount: value })),
  accountNumber: "",
  setAccountNumber: (value) => set(() => ({ accountNumber: value })),
  updateFormValues: (values) => set(() => values),
}));
